import React from "react";
import { Modal } from "@mui/material";
import MainCard from "../MainCard";
import SimpleBar from "../third-party/SimpleBar";

interface Props {
  open: boolean;
  handleClose: () => void;
  children: React.ReactNode;
}

const ReusableModal = ({ open, handleClose, children }: Props) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-add-label"
      aria-describedby="modal-add-description"
      sx={{
        "& .MuiPaper-root:focus": {
          outline: "none",
        },
      }}
    >
      <MainCard
        sx={{
          width: `calc(100% - 48px)`,
          minWidth: 300,
          maxWidth: 700,
          height: "auto",
          maxHeight: "calc(100vh - 48px)",
        }}
        modal
        content={false}
      >
        <SimpleBar
          sx={{
            maxHeight: `calc(100vh - 48px)`,
            "& .simplebar-content": {
              display: "flex",
              flexDirection: "column",
            },
          }}
        >
          {children}
        </SimpleBar>
      </MainCard>
    </Modal>
  );
};

export default ReusableModal;
